/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';

const loginActivityDetail = async (body?: any): Promise<any> => {
  const {isLogin} = body;
  delete body.isLogin;
  const token = useUserStore.getState().userToken;
  const {_id, company, facility, stakeHolderType} =
    useUserStore.getState().userDetails;

  const activityLog = {
    ...body,
    action: isLogin ? 'login' : 'logout',
    activity: isLogin ? 'login' : 'logout',
    apiEndPoint: isLogin ? 'login' : 'logout',
    userId: _id,
    payload: {facility},
    companyId: company ?? body.user?.company,
    actionTaken: `${body.user.name}`,
    stakeHolderType,
    createdBy: _id,
    description: isLogin
      ? `${body.user.name} has logged in successfully`
      : `${body.user.name} has logged out`
  };
  delete body.user;
  delete activityLog.user;
  await axios
    .request({
      method: CRUDMethods.POST,
      url: `${API_BASE_URL}/activitylog`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: activityLog
    })
    .then((response) => {
      return response.data.data;
    })
    .catch(() => {
      return {
        data: [],
        total: 0
      };
    });
};

export default loginActivityDetail;
